import cx from "classnames";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withToast } from "../../../contexts/toastr.context";
import { Button } from "../../../_components";
import { Checkbox } from "../../../_components/form-controls/checkbox.component";
import UIcon from "../../../_components/uicon-component";
import { CommunityService } from "../../../_service";
import { useAppService } from "../../../hooks/use-app-service";

function DefaultJoinGroupComponent({
  community,
  groups,
  isLoadingGroups,
  addToast,
}) {
  const { analyticsService } = useAppService();

  const [cac, setCac] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [groupIdsSelectedToJoin, setGroupIdsSelectedToJoin] = useState({});

  const communityId = community?.id;

  useEffect(() => {
    if (communityId) {
      setIsLoading(true);
      CommunityService.getAdditionalConfiguration(communityId).then(
        (response) => {
          setCac(response.cac);
          setIsLoading(false);
        }
      );
    }
  }, [communityId]);

  const defaultJoinGroups = cac?.defaultJoinGroups ?? [];

  // update selection when default updates
  useEffect(() => {
    const obj = {};
    defaultJoinGroups.forEach((id) => {
      obj[id] = id;
    });
    setGroupIdsSelectedToJoin(obj);
  }, [defaultJoinGroups]);

  const selectedJoinGroups = Object.entries(groupIdsSelectedToJoin)
    .filter((v) => v[1])
    .map((v) => v[0]);

  const updatePreference = () => {
    setIsLoading(true);
    CommunityService.saveAdditionalConfigurationDefaultJoinGroups(
      communityId,
      selectedJoinGroups
    ).then((response) => {
      setCac(response.cac);
      setIsLoading(false);
      analyticsService.track("default-join-groups", {
        joinGroups: [...selectedJoinGroups]
      })
      addToast("Preference updated.");
    });
  };

  return (
    <details className="group" open>
      {/* heading */}
      <summary className="flex justify-between font-semibold p-2 theme-bg-disable cursor-pointer">
        Default Join Groups
        <div className="transition group-open:rotate-180 w-12 flex place-content-center">
          <UIcon icon={"angle-small-up"} className={"h-4"} />
        </div>
      </summary>
      {/* options */}
      <div
        className={cx(
          "transition ease-in-out delay-150 border theme-border-default px-2 theme-bg-default"
        )}>
        {isLoadingGroups ? (
          <div className="py-2">Please wait list loading...</div>
        ) : (
          <>
            {groups.map((group) => {
              const selected = selectedJoinGroups.includes(group.id);
              return (
                <div className="flex py-2" key={group.id}>
                  <Checkbox
                    selected={selected}
                    onClick={(e) => {
                      setGroupIdsSelectedToJoin({
                        ...groupIdsSelectedToJoin,
                        [group.id]: selected ? false : group.id,
                      });
                    }}
                  />
                  <div className="mx-2">{group.name}</div>
                </div>
              );
            })}
            <div className="pb-2">
              <Button
                label="Update"
                isLoading={isLoading}
                disabled={isLoading}
                onClick={updatePreference}
              />
            </div>
          </>
        )}
      </div>
    </details>
  );
}

const DefaultJoinGroup = withToast(
  connect((s) => ({
    groups: s.groups,
    isLoadingGroups: s.isLoadingGroups,
    community: s.community,
  }))(DefaultJoinGroupComponent)
);

export default DefaultJoinGroup;
